// src/features/contact/contactApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '../env';

export const contactApi = createApi({
  reducerPath: 'contactApi',
  baseQuery: fetchBaseQuery({ baseUrl: environment.apiUrl }),
  endpoints: (builder) => ({
    sendContactEmail: builder.mutation({
      query: (contactData) => ({
        url: '/contact/send-email',
        method: 'POST',
        body: contactData,
      }),
    }),
  }),
});

export const { useSendContactEmailMutation } = contactApi;
